import { post } from 'app/utils/axios/kheti'
import { FarmerDetails } from "../models/farmer";

const updateFarmerCrops = async (
  farmerId: string | number,
  crops: string[]
) => {
  try {
    const url = `/farmer-360/v1/farmer/${farmerId}/crops`;
    await post<FarmerDetails>(url, { crop_ids: crops });
    return true;
  } catch (e) {
    return false;
  }
};

export default updateFarmerCrops;
